var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMeat = function SvgMeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Meat_svg__clip0_1811_218038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.298 5.887L.121 9.943l.601 3.207c.479 2.555 2.577 4.592 5.266 4.853a23.03 23.03 0 0012.766-2.446c2.302-1.182 3.513-3.674 3.199-6.123l-.655-3.547z",
    fill: "url(#Meat_svg__paint0_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.121 9.945l.601 3.207c.479 2.555 2.577 4.592 5.266 4.853a23.005 23.005 0 009.303-1.007c.008-1.577-.892-3.115-.892-3.115l-1.207-6.442L.122 9.945z",
    fill: "#935B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.118 9.944c-.892-4.763 3.458-5.507 6.73-5.322 2.553.144 3.992-1.977 5.926-2.97 2.923-1.501 6.495-.322 7.98 2.632 1.484 2.955.318 6.567-2.604 8.068a23.031 23.031 0 01-12.765 2.445c-2.69-.26-4.788-2.298-5.267-4.853z",
    fill: "url(#Meat_svg__paint1_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.849 4.623c-3.273-.185-7.623.56-6.73 5.322.478 2.556 2.576 4.593 5.265 4.853 3.053.296 6.11-.02 9.012-.915-2.947-3.214-6.757-1.167-8.56-4.324C3.829 6.04 6.85 4.623 6.85 4.623z",
    fill: "url(#Meat_svg__paint2_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61 12.726c-6.832 1.308-9.4-1.294-9.741-3.117-.068-.362-.498-2.657 2.268-3.055.751-.108 3.598-.14 4.075-.23 1.616-.31 2.804-1.221 3.851-2.025.53-.407 1.76-1.26 2.63-1.426 1.802-.345 3.642.57 4.474 2.227.503 1 .59 2.138.246 3.205-.344 1.067-2.31 3.369-7.804 4.42z",
    fill: "#F2B4B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.355 6.588a1.787 1.787 0 01-1.409 2.09 1.77 1.77 0 01-2.067-1.424 1.787 1.787 0 011.409-2.09 1.77 1.77 0 012.067 1.425z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.839 9.557c-.746-1.306-.798-2.322-.57-3.084-.486.023-.904.048-1.13.081-2.767.398-2.337 2.693-2.27 3.055.342 1.822 2.91 4.425 9.741 3.117.338-.065.662-.135.974-.208-2.552-1.248-5.297-.423-6.745-2.96z",
    fill: "url(#Meat_svg__paint3_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.996 19.13l-2.348-.407v-2.444l2.348-.408-.391 1.63.391 1.63z",
    fill: "url(#Meat_svg__paint4_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.005 21.165c1.729 0 3.13-1.641 3.13-3.666s-1.401-3.667-3.13-3.667H6.578v7.333h10.427z",
    fill: "url(#Meat_svg__paint5_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.572 21.165c1.945 0 3.521-1.641 3.521-3.666s-1.576-3.667-3.52-3.667c-1.946 0-3.522 1.642-3.522 3.667s1.576 3.666 3.521 3.666z",
    fill: "url(#Meat_svg__paint6_linear_1811_218038)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.612 17.091a.417.417 0 01-.115.288.383.383 0 01-.553 0 .416.416 0 01-.115-.288 3.333 3.333 0 00-.918-2.303 3.072 3.072 0 00-2.212-.956h2.346c.486.38.881.871 1.153 1.437a4.21 4.21 0 01.414 1.822zM17.53 17.091a.416.416 0 01-.115.288.383.383 0 01-.553 0 .416.416 0 01-.115-.288c0-.864-.33-1.692-.918-2.303a3.072 3.072 0 00-2.212-.956h2.346c.486.38.881.871 1.153 1.437.272.566.414 1.19.414 1.822zM5.794 19.13c.432 0 .783-.365.783-.815 0-.45-.35-.815-.783-.815-.432 0-.782.365-.782.815 0 .45.35.815.782.815zM7.747 16.686a.4.4 0 00.391-.407.4.4 0 00-.391-.408.4.4 0 00-.392.408.4.4 0 00.392.407z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint0_linear_1811_218038",
    x1: 21.206,
    y1: 6.581,
    x2: 5.736,
    y2: 18.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2785B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint1_linear_1811_218038",
    x1: 16.594,
    y1: 1,
    x2: 3.254,
    y2: 14.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CAB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint2_linear_1811_218038",
    x1: 7.198,
    y1: 4.598,
    x2: 4.876,
    y2: 15.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCDB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint3_linear_1811_218038",
    x1: 5.226,
    y1: 5.341,
    x2: 6.164,
    y2: 13.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA2A2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA2A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint4_linear_1811_218038",
    x1: 21.93,
    y1: 16.032,
    x2: 19.77,
    y2: 15.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint5_linear_1811_218038",
    x1: 23.311,
    y1: 14.195,
    x2: 13.741,
    y2: 18.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Meat_svg__paint6_linear_1811_218038",
    x1: 7.758,
    y1: 14.195,
    x2: 5.148,
    y2: 21.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58383"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Meat_svg__clip0_1811_218038"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Meat.012a0cd1.svg";
export { SvgMeat as ReactComponent };